import { render, staticRenderFns } from "./mega-menu.vue?vue&type=template&id=1a1709b0&scoped=true"
import script from "./mega-menu.vue?vue&type=script&lang=js"
export * from "./mega-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1709b0",
  null
  
)

export default component.exports